<template>
  <div class="main-content" :id="currentIndex">
    <div class="banner-list" @mousewheel="handleScroll">
      <div class="banner banner1" style="z-index:10;--xy:90%,0">
        <div class="content">
          <div class="left">
            <p class="title1">用科技提供更好的服务</p>
            <p class="title1">让世界看见我们的价值</p>
            <p class="title2" style="width:630px;">
              科技创新赋能高质量发展，推动“智能化”向“智慧化”的转变，
            </p>
            <p class="title2">成为杰出的能源服务企业</p>
            <div style="display: flex;margin-top:30px;">
              <img
                src="@/assets/image/index/circle.png"
                style="width: 24px;height: 24px;margin-right: 10px;"
              />
              <div>
                <span>进一步了解</span>
                <div @click="$router.push({ path: '/about/me' })">关于华成</div>
                <div @click="$router.push({ path: '/about/news' })">
                  公司动态
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div style="display: flex;">
              <span class="title3">2012</span>
              <span class="title4">年</span>
            </div>
            <span class="title2 title2-line">公司成立于2012年</span>
            <div style="display: flex;">
              <span class="title3">44</span>
              <span class="title4">+</span>
            </div>
            <span class="title2">自主知识产权44+</span>
          </div>
        </div>
      </div>
      <div class="banner banner2" style="--xy:0,-90%">
        <div class="content">
          <div class="left">
            <p class="title1">电为中心、绿色低碳</p>
            <p class="title1">助力碳达峰、碳中和</p>
            <p class="title2" style="width:630px;">
              以电为中心提供综合能源服务，引领企业提升能效，助力用户实现“双碳”目标，建立线上线下产业联盟整合资源
            </p>
            <div style="display: flex;margin-top:30px;">
              <img
                src="@/assets/image/index/circle.png"
                style="width: 24px;height: 24px;margin-right: 10px;"
              />
              <div>
                <span>进一步了解</span>
                <div @click="$router.push({ path: '/xny/gfdz' })">光伏电站</div>
                <div @click="$router.push({ path: '/xny/zhny' })">综合能源</div>
                <div @click="$router.push({ path: '/xny/wdw' })">
                  微电网集成
                </div>
                <div @click="$router.push({ path: '/xny/fgcc' })">
                  微电网储能逆变一体柜
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="banner banner3" style="--xy:40%,0">
        <div class="content">
          <div class="left">
            <p class="title1">构建人机协同业务模式</p>
            <p class="title1">专注智能机器人研发</p>
            <p class="title2" style="width:630px;">
              通过提升机器人作业的人机协同能力，减少作业风险，提高作业效率
            </p>
            <div style="display: flex;margin-top:30px;">
              <img
                src="@/assets/image/index/circle.png"
                style="width: 24px;height: 24px;margin-right: 10px;"
              />
              <div>
                <span>进一步了解</span>
                <div @click="$router.push({ path: '/robot/robot-1' })">
                  电力导轨式巡检机器人
                </div>
                <div @click="$router.push({ path: '/robot/robot-3' })">
                  架空地线断股修复机器人
                </div>
                <div @click="$router.push({ path: '/robot/robot-4' })">
                  输电线路绝缘子清洗、喷涂机器人
                </div>
                <div @click="$router.push({ path: '/robot/robot-5' })">
                  架空裸导线绝缘涂覆机器人
                </div>
                <div @click="$router.push({ path: '/robot/robot-6' })">
                  巡检机器人监控管理系统
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="banner banner4" style="--xy:0,90%">
        <div class="content">
          <div class="left">
            <p class="title1">智慧电网建设</p>
            <p class="title1">助力电网业务数字化转型</p>
            <p class="title2" style="width:630px;">
              利用数据孪生、大数据分析、人工智能等技术，构建专业协同、快速统一的管理模式，提升电网业务精益化管理水平，推动业务数字化转型
            </p>
            <div style="display: flex;margin-top:30px;">
              <img
                src="@/assets/image/index/circle.png"
                style="width: 24px;height: 24px;margin-right: 10px;"
              />
              <div>
                <span>进一步了解</span>
                <div @click="$router.push({ path: '/zhjc/gydl' })">
                  高压电缆精益化管理
                </div>
                <div @click="$router.push({ path: '/zhjc/pdzf' })">
                  配电站房精益化管理
                </div>
                <div @click="$router.push({ path: '/zhjc/sdxl' })">
                  输电线路在线监测装置
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="banner banner5" style="--xy:-90%,0">
        <div class="content">
          <div class="left">
            <p class="title1">设立专业研发中心</p>
            <p class="title1">推动企业高质量发展</p>
            <p class="title2" style="width:630px;">
              依托政策支持，加快研发创新，布局新能源、智能装备与数字产业，驱动企业可持续发展
            </p>
            <div style="display: flex;margin-top:30px;">
              <img
                src="@/assets/image/index/circle.png"
                style="width: 24px;height: 24px;margin-right: 10px;"
              />
              <div>
                <span>进一步了解</span>
                <div @click="$router.push({ path: '/about/me' })">关于华成</div>
                <div @click="$router.push({ path: '/about/news' })">
                  公司动态
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="banner banner6" style="--xy:0,-90%">
        <div class="content">
          <div class="left">
            <p class="title1">我们的优势</p>
            <p class="title2" style="width:630px;">
              设有专业技术研发中心，汇聚行业高科技人才；具备专业齐全的资质证书，确保产品与服务的质量和信誉；采用先进的技术设备和设施，准确满足客户的各类需求；凭借深厚的经验和专业知识，为客户提供可靠的解决方案
            </p>
            <div style="display: flex;margin-top:30px;">
              <img
                src="@/assets/image/index/circle.png"
                style="width: 24px;height: 24px;margin-right: 10px;"
              />
              <div>
                <span>进一步了解</span>
              </div>
            </div>
          </div>
        </div>
        <div class="foot">
          <div class="box1">
            <p class="title5">研发实力</p>
            <p class="title6">
              公司设有专业技术研发中心，汇聚高素质人才，聚焦新能源、机器人、智慧监测、智能云仓等方向，在电力与能源领域实现广泛应用。具备高效的研发流程和快速响应能力，持续为客户提供可靠、创新的技术解决方案。
            </p>
          </div>
          <div class="box2">
            <p class="title5">荣誉资质</p>
            <p class="title6">
              公司荣誉：江苏省节能环保出色企业、无锡市互联网成长型企业TOP10、百联网转型服务奖、EPTC智巡榜2023年度新锐企业、2023年电力行业智能巡检技术卓越应用单位。
            </p>
            <p class="title6">
              知识产权及认证：44项知识产权（实用新型专利、发明专利、软件著作权等）；拥有电力施工总承包资质、电力承装承修承试资质、新能源设计乙级资质、CMMI3、ITSS等认证。
            </p>
          </div>
          <div class="box3">
            <p class="title5">优质服务</p>
            <p class="title6">
              我们致力于成为杰出的能源服务企业，秉持“诚信、责任、专业、创新、超越”的核心价值观。作为国家电网、南方电网及各级政府机构、国有企事业单位长期信赖的合作伙伴，提供专业优质的服务，是我们对每一位客户的承诺。
            </p>
          </div>
        </div>
      </div>
    </div>
    <div id="myMenu">
      <div :class="{ select: currentIndex == 1 }" @click="beginBanner(1)">
        <a href=""></a>
      </div>
      <div :class="{ select: currentIndex == 2 }" @click="beginBanner(2)">
        <a href=""></a>
      </div>
      <div :class="{ select: currentIndex == 3 }" @click="beginBanner(3)">
        <a href=""></a>
      </div>
      <div :class="{ select: currentIndex == 4 }" @click="beginBanner(4)">
        <a href=""></a>
      </div>
      <div :class="{ select: currentIndex == 5 }" @click="beginBanner(5)">
        <a href=""></a>
      </div>
      <div :class="{ select: currentIndex == 6 }" @click="beginBanner(6)">
        <a href=""></a>
      </div>
      <div class="arrow-body">
        <div class="arrows"></div>
        <div class="arrows"></div>
        <div class="arrows"></div>
      </div>
      <span>向下滑动</span>
      <span>探索更多</span>
    </div>
    <div class="animation2" v-show="currentIndex == 2">
      <div></div>
      <div></div>
    </div>
    <div id="footer">
      Copyright © 2023 江苏华成协弘科技有限公司 苏ICP备2020060999号-1
    </div>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {
      currentIndex: 1,
      scollStatus: true
    };
  },
  methods: {
    handleScroll(m) {
      // 避免滑动太快
      console.log(!this.scollStatus);
      if (!this.scollStatus) return;
      this.scollStatus = false;
      setTimeout(() => {
        this.scollStatus = true;
      }, 1000);
      var deltaY = m.deltaY;
      // var dom =
      var idx = this.currentIndex;
      if (deltaY > 0) {
        idx++;
        if (idx == 7) {
          idx = 1;
        }
      } else {
        idx--;
        if (idx == 0) {
          idx = 6;
        }
      }
      this.beginBanner(idx, deltaY);
    },
    // 画面缩放效果
    reduce(name) {
      var dom = document.getElementsByClassName(name)[0];
      dom.classList.add("animation-reduce");
      setTimeout(() => {
        dom.classList.remove("animation-reduce");
      }, 1000);
    },
    cssEdit(idx, deltaY = 1) {
      var now = $(".banner" + idx);
      if (deltaY > 0) {
        var prev = $(".banner" + idx).prev().length
          ? $(".banner" + idx).prev()
          : $(".banner" + $(".banner").length);
        console.log(prev);
        prev
          .css("z-index", 10)
          .siblings()
          .css("z-index", 1);
        now.css("z-index", 9);
        setTimeout(() => {
          prev.css("z-index", 1);
        }, 990);
      } else {
        var next = $(".banner" + idx).next().length
          ? $(".banner" + idx).next()
          : $(".banner1");
        next
          .css("z-index", 10)
          .siblings()
          .css("z-index", 1);
        now.css("z-index", 9);
        setTimeout(() => {
          next.css("z-index", 1);
        }, 990);
      }
    },
    beginBanner(idx, deltaY = 1) {
      this.currentIndex = idx;
      var prev = $(".banner" + idx).prev().length
        ? $(".banner" + idx).prev()
        : $(".banner" + $(".banner").length);
      var next = $(".banner" + idx).next().length
        ? $(".banner" + idx).next()
        : $(".banner1");
      var now = $(".banner" + idx);
      var left = document.getElementsByClassName("left")[idx - 1],
        right = document.getElementsByClassName("right")[idx - 1];
      if (deltaY > 0) {
        switch (idx) {
          case 1:
            this.cssEdit(idx, deltaY);
            this.reduce("banner6");
            $(".banner1 .content").hide();
            setTimeout(() => {
              $(".banner1 .content").show();
              left.classList.add("animate__animated", "animate__fadeInLeft");
              right.classList.add("animate__animated", "animate__fadeInRight");
              setTimeout(() => {
                left.classList.remove(
                  "animate__animated",
                  "animate__fadeInLeft"
                );
                right.classList.remove(
                  "animate__animated",
                  "animate__fadeInRight"
                );
              }, 1000);
            }, 500);
            break;
          case 2:
            now
              .css("z-index", 10)
              .siblings()
              .css("z-index", 1);
            $(".banner2 .content").hide();
            setTimeout(() => {
              $(".banner2 .content").show();
              left.classList.add("animate__animated", "animate__fadeInUp");
              setTimeout(() => {
                left.classList.remove("animate__animated", "animate__fadeInUp");
              }, 1000);
            }, 500);
            break;
          case 3:
            this.cssEdit(idx, deltaY);
            this.reduce("banner2");
            $(".banner3 .content").hide();
            setTimeout(() => {
              $(".banner3 .content").show();
              left.classList.add("animate__animated", "animate__zoomIn");
              setTimeout(() => {
                left.classList.remove("animate__animated", "animate__zoomIn");
              }, 1000);
            }, 500);
            break;
          case 4:
            this.cssEdit(idx, deltaY);
            this.reduce("banner3");
            $(".banner4 .content").hide();
            setTimeout(() => {
              $(".banner4 .content").show();
              left.classList.add("animate__animated", "animate__rollIn");
              setTimeout(() => {
                left.classList.remove("animate__animated", "animate__rollIn");
              }, 1000);
            }, 500);
            break;
          case 5:
            this.cssEdit(idx, deltaY);
            this.reduce("banner4");
            $(".banner5 .content").hide();
            setTimeout(() => {
              $(".banner5 .content").show();
              left.classList.add("animate__animated", "animate__fadeInDown");
              setTimeout(() => {
                left.classList.remove(
                  "animate__animated",
                  "animate__fadeInDown"
                );
              }, 1000);
            }, 500);
            break;
          case 6:
            this.cssEdit(idx, deltaY);
            this.reduce("banner5");
            $(".banner6 .content").hide();
            $(".banner6 .foot").hide();
            setTimeout(() => {
              $(".banner6 .content").show();
              $(".banner6 .foot").show();
              left.classList.add("animate__animated", "animate__zoomInRight");
              setTimeout(() => {
                left.classList.remove(
                  "animate__animated",
                  "animate__zoomInRight"
                );
              }, 1000);
            }, 500);
            break;
          default:
            break;
        }
      } else {
        switch (idx) {
          case 1:
            $(".banner2")
              .css("z-index", 10)
              .siblings()
              .css("z-index", 1);
            now.css("z-index", 9);
            $(".banner2").addClass("animationToLeft");
            $(".banner1 .content").hide();
            setTimeout(() => {
              $(".banner1 .content").show();
              left.classList.add("animate__animated", "animate__fadeInLeft");
              right.classList.add("animate__animated", "animate__fadeInRight");
              $(".banner2").css("z-index", 1);
              setTimeout(() => {
                left.classList.remove(
                  "animate__animated",
                  "animate__fadeInLeft"
                );
                right.classList.remove(
                  "animate__animated",
                  "animate__fadeInRight"
                );
                $(".banner2").removeClass("animationToLeft");
              }, 1000);
            }, 1000);
            break;
          case 2:
            now
              .css("z-index", 10)
              .siblings()
              .css("z-index", 1);
            $(".banner2 .content").hide();
            setTimeout(() => {
              $(".banner2 .content").show();
              left.classList.add("animate__animated", "animate__fadeInUp");
              setTimeout(() => {
                left.classList.remove("animate__animated", "animate__fadeInUp");
              }, 1000);
            }, 500);
            break;
          case 3:
            this.cssEdit(idx, deltaY);
            this.reduce("banner4");
            $(".banner3 .content").hide();
            setTimeout(() => {
              $(".banner3 .content").show();
              left.classList.add("animate__animated", "animate__zoomIn");
              setTimeout(() => {
                left.classList.remove("animate__animated", "animate__zoomIn");
              }, 1000);
            }, 500);
            break;
          case 4:
            this.cssEdit(idx, deltaY);
            this.reduce("banner5");
            $(".banner4 .content").hide();
            setTimeout(() => {
              $(".banner4 .content").show();
              left.classList.add("animate__animated", "animate__rollIn");
              setTimeout(() => {
                left.classList.remove("animate__animated", "animate__rollIn");
              }, 1000);
            }, 500);
            break;
          case 5:
            this.cssEdit(idx, deltaY);
            this.reduce("banner6");
            $(".banner5 .content").hide();
            setTimeout(() => {
              $(".banner5 .content").show();
              left.classList.add("animate__animated", "animate__fadeInDown");
              setTimeout(() => {
                left.classList.remove(
                  "animate__animated",
                  "animate__fadeInDown"
                );
              }, 1000);
            }, 500);
            break;
          case 6:
            this.cssEdit(idx, deltaY);
            this.reduce("banner1");
            $(".banner6 .content").hide();
            $(".banner6 .foot").hide();
            setTimeout(() => {
              $(".banner6 .content").show();
              $(".banner6 .foot").show();
              left.classList.add("animate__animated", "animate__zoomInRight");
              setTimeout(() => {
                left.classList.remove(
                  "animate__animated",
                  "animate__zoomInRight"
                );
              }, 1000);
            }, 500);
            break;
          default:
            break;
        }
      }
    }
  },
  created() {
    var left = document.getElementsByClassName("left")[0],
      right = document.getElementsByClassName("right")[0];
    left.classList.add("animate__animated", "animate__fadeInLeft");
    right.classList.add("animate__animated", "animate__fadeInRight");
    setTimeout(() => {
      left.classList.remove("animate__animated", "animate__fadeInLeft");
      right.classList.remove("animate__animated", "animate__fadeInRight");
    }, 1000);
    // setTimeout(() => {
    //   document.getElementsByClassName("foot")[0].style = "";
    // }, 100);
  },
  mounted() {
    $(".banner2 .content").hide();
    $(".banner3 .content").hide();
    $(".banner4 .content").hide();
    $(".banner5 .content").hide();
    $(".banner6 .content").hide();
    $(".banner6 .foot").hide();
  }
};
</script>

<style lang="scss" scoped>
.main-content {
  width: inherit;
  height: inherit;
  min-height: 700px;
  position: relative;
  overflow: hidden;
  .banner-list {
    width: inherit;
    .banner {
      position: absolute;
      z-index: 1;
      top: 0px;
      bottom: 0;
      width: inherit;
      zoom: 1;
      visibility: inherit;
      opacity: 1;
    }
  }
}
.content {
  position: absolute;
  top: 30vh;
  display: flex;
  width: 100%;
  justify-content: space-between;
  .left {
    & > div > div > div {
      opacity: 0;
    }
    & > div:hover {
      cursor: pointer;
      & > div > div {
        opacity: 1;
      }
    }
  }
}
.banner1 {
  background: url("~@/assets/image/index/bg_sy_gsln.png") no-repeat;
  background-size: cover;
}

.banner2 {
  background: url("~@/assets/image/index/bg_sy_zhny.png") no-repeat;
  background-size: cover;
}
.banner3 {
  background: url("~@/assets/image/index/bg_sy_jqr.png") no-repeat;
  background-size: cover;
}
.banner4 {
  background: url("~@/assets/image/index/bg_sy_zhjc.png") no-repeat;
  background-size: cover;
}
.banner5 {
  background: url("~@/assets/image/index/bg_sy_yf.png") no-repeat;
  background-size: cover;
}
.banner6 {
  background: url("~@/assets/image/index/bg_sy_zz.png") no-repeat;
  background-size: cover;
}

.left {
  padding-left: 10vw;
  & > div > div > div {
    cursor: pointer;
    margin-top: 15px;
  }
}

.right {
  position: relative;
  right: 100px;
}
.foot {
  display: flex;
  position: absolute;
  bottom: 0;
  height: 350px;
}
.foot > div {
  width: 33.33%;
  height: 226px;
  padding: 35px 64px;
}
.box1 {
  background: rgba(0, 0, 0, 0.3);
}
.box2 {
  background: rgba(3, 110, 184, 0.3);
}
.box3 {
  background: rgba(0, 0, 0, 0.3);
}

.title1 {
  font-size: 56px;
  line-height: 80px;
}
.title2 {
  margin-right: 100px;
  font-size: 18px;
  line-height: 36px;
}
.title2-line {
  padding-bottom: 10px;
  border-bottom: 2px solid rgba(255, 255, 255, 0.2);
}
.title3 {
  font-size: 52px;
  margin-right: 10px;
}
.title4 {
  font-size: 18px;
  margin-top: 15px;
}
.title5 {
  font-size: 24px;
  line-height: 36px;
  margin-bottom: 15px;
}
.title6 {
  font-size: 16px;
  line-height: 28px;
  color: rgba(255, 255, 255, 0.7);
}

#myMenu {
  z-index: 20;
  position: absolute;
  // transform: translateY(50%);
  transform: translateY(57%);
  right: 3vw;
  display: flex;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  & > div:not(.arrow-body) {
    list-style: none;
    background: rgba(255, 255, 255, 0.3);
    width: 5px;
    // height: 64px;
    height: 52px;
    left: 50%;
  }
  & > div.select {
    background: rgba(255, 255, 255, 0.7);
  }
  & > img {
    margin: 5px 0;
  }
}

#footer {
  z-index: 20;
  position: absolute;
  font-size: 14px;
  left: 50%;
  transform: translateX(-50%);
  bottom: 20px;
  color: #fff;
}

.arrow-body {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-bottom: 10px;
  .arrows {
    position: relative;
    height: 10px;
    width: 10px;
    border-left: 2px solid #fff;
    border-bottom: 2px solid #fff;
    transform: rotate(-45deg);
    animation: arrow-load 2s infinite;
  }

  .arrows:nth-child(1) {
    top: 5px;
    animation-delay: -0.4s;
  }
  .arrows:nth-child(2) {
    top: 2.5px;
    animation-delay: -0.2s;
  }
  .arrows:nth-child(3) {
    right: 0;
  }
  @keyframes arrow-load {
    0% {
      opacity: 0;
    }
    0% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
}

.animationToLeft {
  animation: animation-left 1s ease-in-out;
  animation-fill-mode: forwards;
}
@keyframes animation-left {
  0% {
    left: 0;
  }
  100% {
    left: -100%;
  }
}

.animation2 {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  overflow: hidden;
  div:nth-of-type(1) {
    animation: animation2-left 1.5s ease-in-out;
    animation-fill-mode: forwards;
  }
  div:nth-of-type(2) {
    animation: animation2-right 1.5s ease-in-out;
    animation-fill-mode: forwards;
  }
}
@keyframes animation2-left {
  0% {
    z-index: 99;
    width: 50%;
    height: 100%;
    transform: translateY(0);
    background-color: #fff;
  }
  100% {
    z-index: 0;
    transform: translateY(-100%);
  }
}
@keyframes animation2-right {
  0% {
    z-index: 99;
    width: 50%;
    height: 100%;
    transform: translateY(0);
    background-color: #fff;
  }
  100% {
    z-index: 0;
    transform: translateY(100%);
  }
}
.animation-reduce {
  animation: reduce 1s linear;
  // animation-fill-mode: forwards;
}
@keyframes reduce {
  0% {
    transform: scale(1);
  }
  50% {
    // top: 0;
    transform: scale(0.7);
  }
  100% {
    transform: scale(0.7) translate(var(--xy));
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue